import { render, staticRenderFns } from "./MidTerm.vue?vue&type=template&id=70d1225a&scoped=true"
import script from "./MidTerm.vue?vue&type=script&lang=js"
export * from "./MidTerm.vue?vue&type=script&lang=js"
import style0 from "./MidTerm.vue?vue&type=style&index=0&id=70d1225a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d1225a",
  null
  
)

export default component.exports